<template>
  <div>
    <v-layout wrap style="min-height:100vh;">
      <v-flex sm4 pa-5 class="background">
        <v-container class="d-flex fill-height">
          <v-layout wrap>
            <v-flex xs12>
              <v-img src="@/assets/logo.png" max-width="300" style="margin:0 auto"></v-img>
              <br />
              <h2 style="text-align:center" class="white--text">EXPRESS035</h2>
            </v-flex>
            <v-flex xs12 class="d-flex align-center">
              <h1 class="display-3 white--text">GUIATS</h1>
            </v-flex>
            <v-flex xs12 class="d-flex align-end justify-left">
              <v-flex class="white--text">
                <p class="subtitle">Contacto</p>
                <p>
                  <a
                    class="white--text"
                    style="text-decoration:none"
                    href="tel:6641237179"
                  >664 123 71 79</a>
                </p>
                <p>
                  <a
                    class="white--text"
                    style="text-decoration:none"
                    href="mailto:promocionyventas@human-express.com"
                  >promocionyventas@human-express.com</a>
                </p>
                <p>
                  <a
                    class="white--text"
                    style="text-decoration:none"
                    href="http://human-express.com/"
                  >human-express.com</a>
                </p>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex sm8 pa-5 class="primary">
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs1></v-flex>
            <v-flex xs10 class="d-flex flex-row-reverse">
              <v-btn text class="primary" to="/">Iniciar sesión</v-btn>
            </v-flex>
            <v-flex xs1></v-flex>

            <v-flex xs1></v-flex>
            <v-flex xs10>
              <v-form ref="form" @submit.prevent="send">
                <v-layout wrap>
                  <v-flex xs12>
                    <p class="display-1 white--text">Restablecer Contraseña</p>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="email"
                      dark
                      label="Correo Electrónico"
                      :rules="emailRule"
                      type="email"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs9></v-flex>
                  <v-flex xs3 class="d-flex flex-row-reverse">
                    <v-btn type="submit" rounded class="white" style="padding: 0 1rem">Restablecer</v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
            <v-flex xs1></v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      requiredRule: [v => !!v || "Este campo es obligatorio"],
      emailRule: [
        v => !!v || "Este campo es obligatorio",
        v => /.+@.+\..+/.test(v) || "El correo debe ser valido"
      ],
      email: "",
      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    send() {
      if (this.$refs.form.validate()) {
        let data = {
          email: this.email
        };
        console.log(data);
        axios
          .post(
            this.host + "/session/sendRestorePasswordEmail.php",
            this.createFormData(data)
          )
          .then(response => {
            console.log(response.data);
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  }
};
</script>

<style scoped>
.background {
  background-image: url(../assets/background.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-color: rgba(8, 5, 15, 0.8);
  opacity: 0.8;
}
</style>